import { StyleSheet } from 'aphrodite';
import { black, brandPrimary, brandSecondary, mention, midGrey, navigation, white } from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		padding: 20,
	},
	headerContainer: {
		marginBottom: 8,
		marginLeft: 10,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	description: {
		color: black,
		fontSize: 14,
		lineHeight: 1.5,
		marginTop: 0,
		marginBottom: 16,
		marginLeft: 10,
		maxWidth: 1000,
		backgroundColor: white,
		padding: 20,
		borderRadius: 4,
	},
	cardsContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: 30,
		minHeight: 100,
		position: 'relative',
		...CssSelectors.allChildren({
			flexBasis: '25%',
			flexGrow: 1,
			margin: '20px 1%',
			maxWidth: '28%',
		}),
	},
	addCard: {
		alignItems: 'center',
		backgroundColor: mention,
		borderColor: brandSecondary,
		borderRadius: 5,
		borderStyle: 'dashed',
		borderWidth: 1,
		boxSizing: 'border-box',
		color: brandPrimary,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 18,
		justifyContent: 'center',
		minHeight: 113,
		padding: '25px 21px',
		position: 'relative',
	},
	emptyState: {
		color: navigation,
		textAlign: 'center',
		padding: '40px 20px',
	},
	emptyStateText: {
		color: midGrey,
		fontSize: 14,
		marginTop: 8,
	},
});
